document.addEventListener('DOMContentLoaded', () => {

    const currencyBtnMobile = document.querySelectorAll('.currency-btn.mobile');
    const currencyListMobile = document.querySelectorAll('.currency-list.mobile');
    const closeCurrencyListDropdown = document.querySelectorAll('.currency-list.mobile .close-dropdown');

    // Add active class to mobile currency-list
    if (currencyBtnMobile !== null) {
        for (let i = 0; i < currencyBtnMobile.length; i++) {
            currencyBtnMobile[i].addEventListener('click', () => {
                currencyListMobile[i].classList.toggle('active');
            });
        }
    }

    // Remove active class from mobile currency list on currency close click
    if (closeCurrencyListDropdown !== null) {
        closeCurrencyListDropdown.forEach(function(button){
            button.addEventListener('click', () => {
                button.parentElement.classList.remove('active');
            });
        })
    }

});
